import { render, staticRenderFns } from "./MonitoringSlots.vue?vue&type=template&id=24f60cfa&scoped=true&"
import script from "./MonitoringSlots.vue?vue&type=script&lang=js&"
export * from "./MonitoringSlots.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringSlots.vue?vue&type=style&index=0&id=24f60cfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f60cfa",
  null
  
)

export default component.exports